module.exports = __webpack_public_path__ + "static/PP5s-c2a2793ea0a7af5455a2af00563e00b0.jpg";